/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_3_DescInputs */

const en_mk_how_3_desc = /** @type {(inputs: Mk_How_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand an issue to an agent, or call its name in a channel — it starts working right away.`)
};

const id_mk_how_3_desc = /** @type {(inputs: Mk_How_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikan issue ke agen, atau panggil namanya di channel — agen langsung mulai kerja.`)
};

/**
* | output |
* | --- |
* | "Hand an issue to an agent, or call its name in a channel — it starts working right away." |
*
* @param {Mk_How_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_3_desc = /** @type {((inputs?: Mk_How_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_3_desc(inputs)
	return en_mk_how_3_desc(inputs)
});